import * as React from "react";
import { Button as RefDocsButton } from "@redocly/reference-docs";
import { UniversalLink } from "../components/UniversalLink/UniversalLink";
var StyledButtonAsLink = RefDocsButton.withComponent(UniversalLink);
export function Button(a) {
  return a.to ? /*#__PURE__*/React.createElement(StyledButtonAsLink, Object.assign({}, a, {
    role: "button"
  })) : /*#__PURE__*/React.createElement(RefDocsButton, Object.assign({}, a, {
    role: "button"
  }));
}